import React, { useEffect, useState } from 'react';

import { Flex, useOutsideClick } from '@chakra-ui/react';
import { type IHeaderParams } from 'ag-grid-community';

import { ExpandedMenu } from 'assets/assetsV1/iconComponents';

import { isMobileView } from 'constants/isMobileView';

const SidebarToggle = (props: IHeaderParams) => {
  const { api } = props ?? {};
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  useEffect(() => {
    setIsSidebarOpen(api.isSideBarVisible());
  }, [api]);

  const handleOpenSidebar = () => {
    api?.setGridOption('sideBar', isSidebarOpen ? null : { toolPanels: ['columns'], defaultToolPanel: 'columns' });

    setIsSidebarOpen(!isSidebarOpen);
  };

  const handleCloseSidebar = () => {
    api?.setGridOption('sideBar', isSidebarOpen ? null : { toolPanels: ['columns'], defaultToolPanel: null });

    setIsSidebarOpen(!isSidebarOpen);
  };

  const ref = React.useRef();

  useOutsideClick({
    ref,
    handler: (event) => {
      if (isMobileView()) {
        const parentRef = document.querySelector('.ag-column-panel');

        // @ts-ignore
        if (isSidebarOpen && parentRef && !parentRef.contains(event?.target)) {
          // Clicked outside the div
          handleCloseSidebar();
        }
      }
    },
  });

  return (
    // @ts-expect-error: complex union
    <Flex
      alignItems="center"
      justifyContent="flex-end"
      paddingRight="calc(var(--ag-cell-horizontal-padding) + 1rem)"
      w="100%"
      h="100%"
      cursor="pointer"
      background={isSidebarOpen ? '#EBEFF3' : 'transparent'}
      onClick={() => (isSidebarOpen ? handleCloseSidebar() : handleOpenSidebar())}
      ref={ref}
    >
      <ExpandedMenu width="16px" />
    </Flex>
  );
};

export { SidebarToggle };
